import * as React from "react";
import { useNavigate } from "react-router-dom";
import { setPushNavigate } from "./navigation";

export function PushNavigationBridge() {
  const navigate = useNavigate();

  React.useEffect(() => {
    setPushNavigate((path) => navigate(path));
  }, [navigate]);

  return null;
}
